"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalculateUtils = exports.CALC_INVALID_ORDER_QTY = exports.CALC_ELQ_FAILURE = exports.CALC_INVALID_ORDER_PRICE = exports.CALC_INVALID_AVAILABLE = exports.CALC_CLOSE_POSITION = exports.CALC_UNSUPPORTED_ORDER_TYPE = exports.CALC_NO_LEVERAGE_CONFIG = void 0;
const decimal_js_1 = __importDefault(require("decimal.js"));
const trade_utils_lib_1 = require("trade_utils_lib");
const interface_1 = require("../../../interface");
// error definitions
/**未获取到杠杆配置 */
exports.CALC_NO_LEVERAGE_CONFIG = { code: "0025100010", message: "local: not found leverage config" };
/**不支持的下单类型 */
exports.CALC_UNSUPPORTED_ORDER_TYPE = { code: "0025100011", message: "local: only support Futures order type" };
/**完全平仓 */
exports.CALC_CLOSE_POSITION = { code: "0025100012", message: "local: close position" };
/**可用非法 */
exports.CALC_INVALID_AVAILABLE = { code: "0025100013", message: "local:available is invalid" };
/**不可用的价格 */
exports.CALC_INVALID_ORDER_PRICE = { code: "0025100014", message: "local:order Price is invalid" };
/**算不出来 */
exports.CALC_ELQ_FAILURE = { code: "0025100015", message: "local:cannot estimated Liquidation Price" };
/**qty是0 */
exports.CALC_INVALID_ORDER_QTY = { code: "0025100016", message: "local:order qty is invalid" };
var CalculateUtils;
(function (CalculateUtils) {
    function getTradeFeeRate(params) {
        const { postOnly } = params;
        return postOnly ? 0.0002 : 0.0005;
    }
    CalculateUtils.getTradeFeeRate = getTradeFeeRate;
    function isTradeByBase(params) {
        const { orderType, investSide } = params;
        return (orderType === interface_1.CustomOrderType.LIMIT && investSide === interface_1.InvestSymbolSide.quote) === false;
    }
    CalculateUtils.isTradeByBase = isTradeByBase;
    function getTradeQty(params) {
        const { qty, price, orderSide } = params;
        let _realQty = new trade_utils_lib_1.SafeDecimal(qty);
        // 用户投quote的时候需要把数值转换成base
        if (!isTradeByBase(params)) {
            _realQty = _realQty.div(new trade_utils_lib_1.SafeDecimal(price));
        }
        if (orderSide === interface_1.CustomOrderSide.SELL) {
            _realQty = _realQty.mul(-1);
        }
        return _realQty.toString();
    }
    CalculateUtils.getTradeQty = getTradeQty;
    function getTradePrice(params) {
        const { orderType, price, curPrice } = params;
        const isLimitOrder = orderType === interface_1.CustomOrderType.LIMIT;
        return isLimitOrder ? price : curPrice;
    }
    CalculateUtils.getTradePrice = getTradePrice;
    function mergeLastPosition(userQty, userPrice, lastPosition) {
        // 是否是限价单
        const realPrice = new trade_utils_lib_1.SafeDecimal(userPrice);
        const [mergedAvgPrice, mergedQty, positionSide] = (() => {
            let qty = new trade_utils_lib_1.SafeDecimal(userQty);
            if (lastPosition) {
                // 已经存在仓位，需要判断最终的仓位方向
                const { positionQuantity, position_side, amount_long, amount_short, amount_settle, avgPrice: _avgPrice } = lastPosition;
                qty = qty.add(positionQuantity);
                if (qty.eq(0)) {
                    // 刚好完全平仓，啥也不做
                    return [];
                }
                const mergedSide = qty.gt(0) ? interface_1.FuturePositionSide.LONG : interface_1.FuturePositionSide.SHORT;
                if (mergedSide === position_side) {
                    // 仓位方向不变
                    if (qty.abs().gt(new trade_utils_lib_1.SafeDecimal(positionQuantity).abs())) {
                        // 同方向加仓
                        const newAvgPrice = new trade_utils_lib_1.SafeDecimal(amount_long)
                            .add(amount_short || 0)
                            .add(amount_settle || 0)
                            .abs()
                            .add(new trade_utils_lib_1.SafeDecimal(realPrice).mul(userQty))
                            .abs()
                            .div(qty)
                            .abs();
                        // 加仓
                        // 计算加仓后的持仓均价：需要拿之前的价格跟当前的价格算均价
                        // (历史仓位的持仓价值 + 新开仓位的持仓价值)/累加后的数量
                        return [newAvgPrice, qty, mergedSide];
                    }
                    else {
                        // 同方向减仓
                        // 计算减仓的均价：直接使用历史仓位的持仓均价
                        return [new trade_utils_lib_1.SafeDecimal(_avgPrice), qty, mergedSide];
                    }
                }
                else {
                    // 仓位反向
                    // 直接使用最新的价格
                    return [new trade_utils_lib_1.SafeDecimal(realPrice), qty, mergedSide];
                }
            }
            else {
                const mergedSide = qty.gt(0) ? interface_1.FuturePositionSide.LONG : interface_1.FuturePositionSide.SHORT;
                // 不存在仓位，直接使用当前的价格
                return [new trade_utils_lib_1.SafeDecimal(realPrice), qty, mergedSide];
            }
        })();
        if (!mergedQty || mergedQty.eq(0)) {
            // 完全平仓
            return undefined;
        }
        return {
            mergedAvgPrice: mergedAvgPrice.toString(),
            mergedQty: mergedQty.toString(),
            positionSide: positionSide,
            realPrice: userPrice,
        };
    }
    function estimatedLiquidationPrice(tradeParams, qty, mergedOrder, leverageConfigs) {
        const { mergedAvgPrice, mergedQty, positionSide, realPrice } = mergedOrder;
        const { postOnly, available } = tradeParams;
        // 手续费 postOnly是万2，其他时候是万5
        // 手续费外部传入
        const feeRate = CalculateUtils.getTradeFeeRate({ postOnly });
        // 用户输入的量
        const sourceQty = new trade_utils_lib_1.SafeDecimal(qty).abs();
        // 跟上一次仓位合并后的量
        const mQty = new trade_utils_lib_1.SafeDecimal(mergedQty).abs();
        // 倒序
        const sortedLeverage = leverageConfigs.sort((a, b) => b.row_num - a.row_num);
        if (positionSide === interface_1.FuturePositionSide.SHORT) {
            // 累计做空 X = (AV - QTY*AP*FR + mQTY*mAP + Q) / (mQTY + QTY*R)
            // AV - QTY*AP*FR + mQTY*mAP
            const calcMemo = new trade_utils_lib_1.SafeDecimal(available).sub(sourceQty.mul(realPrice).mul(feeRate)).add(mQty.mul(mergedAvgPrice));
            for (let i = 0; i < sortedLeverage.length; i++) {
                const { quick_deduction, notional_limit: curLimit, maint_margin_ratio, row_num } = sortedLeverage[i];
                const elq = calcMemo.add(quick_deduction).div(mQty.add(sourceQty.mul(maint_margin_ratio)));
                if (i === sortedLeverage.length - 1) {
                    // 最后一个档位，直接返回
                    return elq.toString();
                }
                else {
                    // 验证：当前档位的notional_limit > 开仓数量*预估强平价 > 上一个档位notional_limit
                    const positionValue = sourceQty.mul(elq);
                    const { notional_limit: prevLimit } = sortedLeverage[i + 1];
                    // 做空时强平价格必须是大于当前价格
                    if (elq.gt(realPrice) && positionValue.gt(prevLimit) && positionValue.lte(curLimit)) {
                        return elq.toString();
                    }
                }
            }
        }
        else {
            // 累计做多 X = (AV - QTY*AP*FR - mQTY*mAP + Q) / (QTY*R - mQTY)
            // AV - QTY*AP*FR - mQTY*mAP
            const calcMemo = new trade_utils_lib_1.SafeDecimal(available).sub(sourceQty.mul(realPrice).mul(feeRate)).sub(mQty.mul(mergedAvgPrice));
            for (let i = 0; i < sortedLeverage.length; i++) {
                const { quick_deduction, notional_limit: curLimit, maint_margin_ratio, row_num } = sortedLeverage[i];
                const elq = calcMemo.add(quick_deduction).div(sourceQty.mul(maint_margin_ratio).sub(mQty));
                if (i === sortedLeverage.length - 1) {
                    // 最后一个档位，直接返回
                    return elq.toString();
                }
                else {
                    // 验证：当前档位的notional_limit > 开仓数量*预估强平价 > 上一个档位notional_limit
                    const positionValue = sourceQty.mul(elq);
                    const { notional_limit: prevLimit } = sortedLeverage[i + 1];
                    // 做多时强平价格必须是小于当前价格
                    if (elq.lt(realPrice) && positionValue.gt(prevLimit) && positionValue.lte(curLimit)) {
                        return elq.toString();
                    }
                }
            }
        }
        return "";
    }
    function getLiquidatePrice(params) {
        var _a;
        const { tradeParams, lastPosition, leverageConfigs: _leverageConfigs } = params;
        const { orderType, symbolInfo } = tradeParams;
        const leverageConfigs = _leverageConfigs || [];
        // 未获取到杠杆配置
        if (!(leverageConfigs === null || leverageConfigs === void 0 ? void 0 : leverageConfigs.length)) {
            throw exports.CALC_NO_LEVERAGE_CONFIG;
        }
        // 订单类型非法
        if (![interface_1.CustomOrderType.LIMIT, interface_1.CustomOrderType.MARKET_QTY].includes(orderType)) {
            throw exports.CALC_UNSUPPORTED_ORDER_TYPE;
        }
        // FIXME:方向持仓
        // const availableDecimal = new SafeDecimal(available);
        // if (availableDecimal.lte(0)) {
        //     // 可用非法
        //     return throwError(CALC_INVALID_AVAILABLE);
        // }
        // 获取下单价格
        const realPrice = CalculateUtils.getTradePrice(tradeParams);
        if (new trade_utils_lib_1.SafeDecimal(realPrice).lte(0)) {
            // 非法的下单价格
            throw exports.CALC_INVALID_ORDER_PRICE;
        }
        let realQty = new trade_utils_lib_1.SafeDecimal(CalculateUtils.getTradeQty(tradeParams));
        // qty非法
        if (realQty.eq(0)) {
            throw exports.CALC_INVALID_ORDER_QTY;
        }
        const mergedOrder = mergeLastPosition(realQty.toString(), realPrice, lastPosition);
        if (!mergedOrder) {
            // 不存在合并后的订单则代表完全平仓
            throw exports.CALC_CLOSE_POSITION;
        }
        const elq = estimatedLiquidationPrice(tradeParams, realQty.toString(), mergedOrder, leverageConfigs);
        if (!elq) {
            throw exports.CALC_ELQ_FAILURE;
        }
        const precision = (_a = symbolInfo.precision) !== null && _a !== void 0 ? _a : 0;
        const liqPrice = new trade_utils_lib_1.SafeDecimal(elq);
        // 如果预估强平加为负数，则显示0
        return liqPrice.lte(0)
            ? new trade_utils_lib_1.SafeDecimal(0).toFixed(precision, decimal_js_1.default.ROUND_FLOOR)
            : liqPrice.toFixed(precision, decimal_js_1.default.ROUND_FLOOR);
    }
    /**
     * @description 全仓模式下，传入历史仓位以及新开的仓位，以及当前币种的阶梯杠杆配置，计算出预估强平价格
     *
     * > 参考公式：Available = 开仓数量x开仓价格x手续费率(taker/maker) + (合并后的开仓数量)x(P-持仓均价)x仓位方向(买入做多/卖出做空) + 开仓数量xPx当前仓位价值对应档位的维持保证金率
     *   参考公式：Available = 手续费 + 盈亏 + 维持保证金
     * 设当前可用为AV,开仓价格是P, 持仓均价为AP，开仓数量为QTY,开仓手续费率为FR
     *
     * 合并后的开仓数量为mQTY,持仓均价未mAP
     *
     * 当前杠杆对应的保证金率为R，速算扣除数为Q
     *
     * 仓位方向：买入做多时为 负1 卖出做空时为 正1
     *
     * 1. 累计做多
     *
     * ```
     * AV = QTY*AP*FR + mQTY*(X - mAP)*(-1) + (QTY*X*R - Q)
     * AV = QTY*AP*FR - mQTY* X + mQTY*mAP + QTY*X*R - Q
     * AV = QTY*AP*FR  + mQTY*mAP - Q + (QTY*R - mQTY)*X
     * X = (AV - QTY*AP*FR - mQTY*mAP + Q) / (QTY*R - mQTY)
     * ```
     *
     * 累计做空
     *
     * ```
     * AV = QTY*AP*FR + mQTY*(X - mAP)*1 + QTY*X*R - Q
     * AV = QTY*AP*FR + mQTY* X - mQTY*mAP + QTY*X*R - Q
     * AV = QTY*AP*FR  - mQTY*mAP - Q + (mQTY + QTY*R)*X
     * X = (AV - QTY*AP*FR + mQTY*mAP + Q) / (mQTY + QTY*R)
     * ```
     *
     * @returns
     */
    function calculateLiquidatePrice(params) {
        try {
            return getLiquidatePrice(params);
        }
        catch (error) { }
        return "";
    }
    CalculateUtils.calculateLiquidatePrice = calculateLiquidatePrice;
})(CalculateUtils = exports.CalculateUtils || (exports.CalculateUtils = {}));
